import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useI18n } from "../lib/i18n";
import { fmtDate } from "../lib/format";
import { Camera, MapPin, FileText } from "lucide-react";

export default function Evidences() {
  const { t } = useI18n();
  const [evs, setEvs] = useState([]);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/evidences");
      setEvs(data);
    })();
  }, []);

  const filtered = filter === "all" ? evs : evs.filter((e) => e.kind === filter);
  const KINDS = ["all", "photo", "signature", "ar", "receipt", "document"];

  return (
    <div className="space-y-4">
      <div className="card-soft px-5 py-4">
        <div className="text-xs text-[var(--text-2)] font-medium">Validade jurídica</div>
        <h1 className="font-display text-2xl font-bold tracking-tight mt-0.5">{t("nav_evidences")}</h1>
      </div>

      <div className="flex flex-wrap gap-2">
        {KINDS.map((k) => (
          <button
            key={k}
            onClick={() => setFilter(k)}
            className={`px-4 h-9 rounded-2xl text-xs font-semibold transition ${filter === k ? "bg-[var(--brand)] text-white" : "bg-[var(--surface)] border border-[var(--border-c)] hover:bg-[var(--brand-soft)] hover:text-[var(--brand)]"}`}
            data-testid={`evidence-filter-${k}`}
          >
            {k === "all" ? "Todos" : t(`evidence_kind_${k}`)}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
        {filtered.length === 0 && <div className="col-span-full text-sm text-[var(--text-2)] text-center py-12">{t("no_data")}</div>}
        {filtered.map((e) => {
          const isImg = e.content_type?.startsWith("image/");
          return (
            <div key={e.id} className="card-soft overflow-hidden group" data-testid={`evidence-card-${e.id}`}>
              <a href={`${process.env.REACT_APP_BACKEND_URL}/api/evidences/${e.id}/download`} target="_blank" rel="noreferrer">
                <div className="aspect-square bg-gradient-to-br from-[var(--surface-2)] to-[var(--brand-soft)] flex items-center justify-center relative overflow-hidden">
                  {isImg ? <Camera size={48} className="text-[var(--brand)]" /> : <FileText size={48} className="text-[var(--brand)]" />}
                  <span className="absolute top-3 left-3 pill pill-info">{t(`evidence_kind_${e.kind}`)}</span>
                  {e.lat && <span className="absolute bottom-3 left-3 pill pill-neutral"><MapPin size={10} /></span>}
                </div>
              </a>
              <div className="p-3 text-xs">
                <div className="font-mono text-[10px] text-[var(--text-2)] truncate">{e.original_filename}</div>
                <div className="text-[var(--text-2)] mt-1">{fmtDate(e.created_at)}</div>
                <div className="text-[var(--text-1)] mt-0.5 truncate font-medium">{e.user_email}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
